import React from "react";
import { Flame, Mail, Send } from "lucide-react";
import { Link } from "react-router-dom";
import SocialFollow from "../SocialFollow";

const NAV = [
  ["Home", "/"],
  ["About", "/about"],
  ["Request Prayer", "/request-prayer"],
  ["Service Recordings", "/service-recordings"],
  ["Events", "/events"],
  ["Mentorship", "/prophetic-mentorship"],
  ["Articles", "/articles"],
  ["Give", "/give"],
  ["Contact", "/contact"],
];

const MINISTRY = [
  ["Prayer Ministry", "/prayer-ministry"],
  ["Deliverance Ministry", "/deliverance-ministry"],
  ["Healing Ministry", "/healing-ministry"],
  ["Prophetic Ministry", "/prophetic-ministry"],
  ["Marriage Counseling", "/marriage-counseling"],
  ["Prayer for My Marriage", "/prayer-for-my-marriage"],
  ["Tent Revivals & Crusades", "/tent-revivals-and-crusades"],
];

const GIVING = [
  ["Cash App · $RevivalFireGlobal", "https://cash.app/$RevivalFireGlobal"],
  ["PayPal · Revivalfireteam@gmail.com", "https://www.paypal.com/paypalme/Revivalfireteam"],
  ["Zelle · RevivalFireteam@gmail.com", "mailto:RevivalFireteam@gmail.com"],
];

const Footer = () => {
  return (
    <footer className="relative pt-20 pb-12 px-6 border-t border-[#C9A44C]/15 bg-[#050505]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Link to="/" className="flex items-center gap-3">
            <span className="icon-badge !h-10 !w-10">
              <Flame className="h-5 w-5 text-[#F28C18]" strokeWidth={1.5} />
            </span>
            <div>
              <div className="text-[11px] tracking-[0.28em] uppercase text-[#C9A44C]">Revival Fire Ministries Global</div>
              <div className="font-serif-display text-2xl text-[#F6F0E6] -mt-0.5">RFMG Connect</div>
            </div>
          </Link>
          <p className="mt-6 text-[#D9D9D9] text-sm leading-relaxed max-w-md">
            A prophetic and apostolic holiness revival movement — calling the hearts of
            men back to Jesus Christ through the unadulterated Word of God with power
            and demonstration of the Spirit of God.
          </p>
          <p className="mt-6 font-serif-display italic text-[#C9A44C] text-lg">
            Come and meet Jesus. Carry the fire.
          </p>
          <div className="mt-6">
            <SocialFollow variant="compact" />
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-4">Navigation</div>
          <ul className="space-y-2.5">
            {NAV.map(([l, h]) => (
              <li key={h}>
                <Link to={h} className="text-[#D9D9D9] hover:text-[#F6F0E6] transition-colors text-sm" data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}>{l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-4">Ministry</div>
          <ul className="space-y-2.5">
            {MINISTRY.map(([l, h]) => (
              <li key={h}>
                <Link to={h} className="text-[#D9D9D9] hover:text-[#F6F0E6] transition-colors text-sm">{l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Connect & Give</div>
          <ul className="space-y-2.5 mb-5">
            {GIVING.map(([l, h]) => (
              <li key={h}>
                <a href={h} target="_blank" rel="noopener noreferrer" className="text-[#D9D9D9] hover:text-[#C9A44C] transition-colors text-sm break-all">{l}</a>
              </li>
            ))}
          </ul>
          <a href="mailto:rfmgcontact@gmail.com" className="inline-flex items-center gap-2 text-sm text-[#F6F0E6] hover:text-[#C9A44C]" data-testid="footer-email">
            <Mail className="h-4 w-4 text-[#C9A44C]" strokeWidth={1.6} />
            rfmgcontact@gmail.com
          </a>
          <div className="mt-3">
            <a href="https://t.me/+5JNzlS_s3ac0NmUx" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-[#F6F0E6] hover:text-[#C9A44C]" data-testid="footer-telegram">
              <Send className="h-4 w-4 text-[#C9A44C]" strokeWidth={1.6} />
              Telegram
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-[#C9A44C]/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#D9D9D9]/60">
        <div>© {new Date().getFullYear()} Revival Fire Ministries Global. All rights reserved.</div>
        <div className="tracking-[0.22em] uppercase">RFMG Connect</div>
      </div>
    </footer>
  );
};

export default Footer;
